import { setPermitsHistoryById, setPermitsHistoryTimeout } from 'app/store/dcra-inspections/inspections';
import { WebsocketMessage } from 'app/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export interface InspectionsHistoryProps {
  message: WebsocketMessage;
}

/**
 * For Permit Inspections History
 * @param props
 * @returns
 */
export default function InspectionsHistory(props: InspectionsHistoryProps) {
  const { message } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    if (message.model.error) {
      dispatch(setPermitsHistoryTimeout(message.model.permit_id));
    } else {
      dispatch(setPermitsHistoryById(message.model.permit_id, message.model.recInsps));
    }
  }, [message.uuid]);

  return null;
}
